import { useSelector } from 'react-redux';

import { FeaturesEnums } from 'src/shared/enums';
import { validateListContains } from 'src/shared/utils';
import { RootState } from 'src/store/types';

export const useFeatures = (features: FeaturesEnums | FeaturesEnums[], strict?: boolean): boolean => {
  const { info } = useSelector((state: RootState) => state.user);
  return validateListContains(features, info?.features, 'featureId', 'featureDisabled', strict);
};
